"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var OnUpdate =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(OnUpdate, _React$Component);

  function OnUpdate() {
    (0, _classCallCheck2.default)(this, OnUpdate);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(OnUpdate).apply(this, arguments));
  }

  (0, _createClass2.default)(OnUpdate, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.cb();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return OnUpdate;
}(_react.default.Component);

exports.default = OnUpdate;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9PblVwZGF0ZS5qcyJdLCJuYW1lcyI6WyJPblVwZGF0ZSIsInByb3BzIiwiY2IiLCJSZWFjdCIsIkNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBOztJQUtxQkEsUTs7Ozs7Ozs7Ozs7O3lDQUNFO0FBQ25CLFdBQUtDLEtBQUwsQ0FBV0MsRUFBWDtBQUNEOzs7NkJBRWE7QUFDWixhQUFPLElBQVA7QUFDRDs7O0VBUG1DQyxlQUFNQyxTIiwic291cmNlc0NvbnRlbnQiOlsiLyogQGZsb3cgKi9cblxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxudHlwZSBQcm9wcyA9IHtcbiAgY2I6IEZ1bmN0aW9uO1xufTtcbmV4cG9ydCBkZWZhdWx0IGNsYXNzIE9uVXBkYXRlIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50PFByb3BzPiB7XG4gIGNvbXBvbmVudERpZFVwZGF0ZSgpIHtcbiAgICB0aGlzLnByb3BzLmNiKCk7XG4gIH1cblxuICByZW5kZXIoKTogYW55IHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/react-draggable-list/js/OnUpdate.js
// module id = 1020
// module chunks = 0